import { render } from "./OperatorTraders.vue?vue&type=template&id=37b7194e&ts=true"
import script from "./OperatorTraders.vue?vue&type=script&lang=ts"
export * from "./OperatorTraders.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__